/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Reportinghistory_Period2Inputs */

const en_coinvestments_report_reportinghistory_period2 = /** @type {(inputs: Coinvestments_Report_Reportinghistory_Period2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Period`)
};

/**
* | output |
* | --- |
* | "Period" |
*
* @param {Coinvestments_Report_Reportinghistory_Period2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_reportinghistory_period2 = /** @type {((inputs?: Coinvestments_Report_Reportinghistory_Period2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Reportinghistory_Period2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_reportinghistory_period2(inputs)
});
export { coinvestments_report_reportinghistory_period2 as "coInvestments_report_reportingHistory_period" }